import { ProjectTypeCardProps } from '@/shared/properties/CardProps';
import Link  from 'next/link';

export function ProjectTypeCard({
  title,
  description,
  icon: Icon,
  iconBg = 'bg-blue-500',
  onClick,
  href,
}: ProjectTypeCardProps) {
  const content = (
    <div className="flex flex-row items-center gap-4">
        <div className={`flex h-14 w-14 items-center justify-center rounded-2xl ${iconBg} shadow-sm`}>
            <Icon className="h-7 w-7 text-white" />
        </div>
        <div className="text-left">
            <p className="text-sm font-semibold text-gray-900">{title}</p>
            <p className="mt-1 text-xs text-gray-500">{description}</p>
        </div>
    </div>
  );

  const baseClass =
    'group flex w-full flex-col rounded-2xl border border-gray-200 bg-white p-5 shadow-sm transition-all duration-150 hover:border-blue-400 hover:shadow-md cursor-pointer';

  return href? (
    <Link href={href} className={baseClass}>
        {content}
    </Link>
    
  ) : (
    <button type="button" onClick={onClick} className={baseClass}>
      {content}
    </button>
  );
}
